import dropdownEvent from './base/_dropdownEvent';
import { children, focusable } from './base/_traverse';
import { afterTransition } from './base/_effects';

class Navigation {
	constructor() {
		this.header = document.querySelector('.header');

		if (!this.header) {
			return;
		}

		this.opened = null;
		this.bodyThreshold = 10;
		this.activeItemClass = 'nav__menu-item--active';

		this.headerOpenedClass = 'header--open';
		this.searchOpenedClass = 'header--open-search';
		this.menuOpenedClass = 'header--open-menu';

		this.desktopSearchToggle = this.header.querySelector('.header__search--desktop .header__search-toggle');
		this.searchForm = this.header.querySelector('.header__search-form');
		this.headerContent = this.header.querySelector('.header__content');

		// click handler delegation
		this.header.addEventListener('click', (e) => {
			let { target } = e;

			while (target && target.parentNode) {
				// open the menu
				if (target.matches('.header__menu-toggle')) {
					return this.toggle('menu');
				}

				// open the search
				if (target.matches('.header__search-toggle')) {
					return this.toggle('search');
				}

				// close the search on desktop
				if (target.matches('.header__search-close')) {
					return this.close();
				}

				// toggle a submenu on mobile
				if (target.matches('.nav__menu-toggler')) {
					let tpn = target.parentNode;
					setTimeout((target) => {
						if (tpn.classList.contains('nav__menu-item--active') === true && tpn.classList.contains('first-time') === false) {
							//return tpn.classList.toggle(this.activeItemClass);
							return tpn.classList.toggle('first-time');
						} else {
							return tpn.classList.toggle(this.activeItemClass);
						}
					}, 10);

				}

				target = target.parentNode;
			}
		});

		const dropdownActivate = (e) => {
			const { target } = e;

			// dont bother with mobile or if it's already active
			if ('desktop' !== this.getMode() || target.classList.contains(this.activeItemClass)) {
				return;
			}

			target.classList.add(this.activeItemClass);

			const subMenu = children(target, '.nav__menu').shift();

			if (subMenu) {
				// prevent the menu from being offscreen
				let rect = subMenu.getBoundingClientRect();

				if (rect.left < this.bodyThreshold) {
					// off left
					subMenu.style.marginLeft = `${rect.left + this.bodyThreshold}px`;
				} else if (rect.right > document.body.clientWidth - this.bodyThreshold) {
					// off right
					subMenu.style.marginLeft = `${(rect.right - document.body.clientWidth + this.bodyThreshold) * -1}px`;
				}
			}
		}

		const dropdownDeactivate = (e) => {
			const { target } = e;

			// dont bother with mobile or if it's not active
			if ('desktop' !== this.getMode() || !target.classList.contains(this.activeItemClass)) {
				return;
			}

			target.classList.remove(this.activeItemClass);
			target.classList.remove('first-time');
			const subMenu = children(target, '.nav__menu').shift();

			if (subMenu) {
				subMenu.style.marginLeft = '';
			}
		}

		this.dropdowns = Array.from(this.header.querySelectorAll('.nav__menu-item--has-children')).map((node) => {
			node.addEventListener('dropdown:activate', dropdownActivate);
			node.addEventListener('dropdown:deactivate', dropdownDeactivate);
			return dropdownEvent(node);
		});
	}

	getMode() {
		return window.matchMedia('(min-width: 960px)').matches ? 'desktop' : 'mobile';
	}

	open(which) {
		this.opened = which;
		this.header.classList.add(this.headerOpenedClass);

		if ('mobile' === this.getMode()) {
			document.body.style.overflow = 'hidden';
		}

		switch (which) {
			case 'menu':
				this.header.classList.add(this.menuOpenedClass);
				this.header.classList.remove(this.searchOpenedClass);
				break;
			case 'search':
				this.header.classList.add(this.searchOpenedClass);
				this.header.classList.remove(this.menuOpenedClass);
				afterTransition(this.header, () => focusable(this.searchForm));
				break;
		}
	}

	close() {
		this.opened = null;
		[this.headerOpenedClass, this.searchOpenedClass, this.menuOpenedClass].forEach(className => this.header.classList.remove(className));
		document.body.style.overflow = '';

		if (this.desktopSearchToggle && 'desktop' === this.getMode()) {
			this.desktopSearchToggle.focus();
		}
	}

	toggle(which = 'menu') {
		return this.opened === which ? this.close() : this.open(which);
	}
}

export default Navigation;
